import { Pill } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";

import { STATUS_CONFIG } from "../constants";
import { type ProfessionalReferenceStatus } from "../types";

interface ProfessionalReferencesStatusPillProps {
  status: ProfessionalReferenceStatus;
  referenceFirstName?: string;
}

export function ProfessionalReferencesStatusPill({
  status,
  referenceFirstName,
}: ProfessionalReferencesStatusPillProps) {
  const statusConfig = STATUS_CONFIG[status];

  if (!isDefined(statusConfig)) {
    return null;
  }

  const { intent } = statusConfig;
  const label =
    status === "requested" && isDefined(referenceFirstName) && referenceFirstName.length > 0
      ? `Awaiting verification from ${referenceFirstName}`
      : statusConfig.label;

  return (
    <Pill
      size="small"
      label={label}
      backgroundColor={(theme) => theme.palette.intent?.[intent]?.background}
      color={(theme) => theme.palette.intent?.[intent]?.text}
      iconColor={(theme) => theme.palette.intent?.[intent]?.icon}
      sx={{ width: "fit-content" }}
    />
  );
}
